import Vue from 'vue'
import App from './App.vue'
import router from  './router'
import store from './store'
import  Vant from 'vant'
import 'vant/lib/index.css'
import './assets/styles/main.less'
import scroll from 'vue-seamless-scroll'
import  bridge  from './bridge';
import WxPlugin from '@/utils/share'
import VueScrollactive from 'vue-scrollactive';
import WX from 'weixin-js-sdk'

Vue.use(VueScrollactive);
Vue.use(WxPlugin)
Vue.use(scroll)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.config.devtools = true;
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
import { initDirectives } from './directives';
import NavBar from '@/components/navBar'
Vue.component('NavBar', NavBar)
initDirectives();
Vue.prototype.WX = WX

Vue.use(AlloyFingerPlugin,{
  AlloyFinger
})

Vue.use(Vant)
Vue.use(bridge)
//动态修改页面title
Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
